export default {"src":"/_next/static/media/Parma.3dd19d59.svg","height":250,"width":205,"blurWidth":0,"blurHeight":0};